<template>
  <div
    style="
      align-content: center;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
    "
    ref="gridContainer"
  >
    <div
      v-for="(child, index) of children"
      :key="index"
      :style="{
        width: itemWidth + 'px',
        height: itemHeight + 'px',
        margin: margin + 'px',
        position: 'relative',
      }"
    >
      <slot name="child" v-bind:child="child" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["children", "margin", "aspectRatio"],
  data() {
    return {
      itemWidth: 0,
      itemHeight: 0,
    };
  },
  watch: {
    margin() {
      this.onResize();
    },
    aspectRatio() {
      this.onResize();
    },
    children() {
      this.onResize();
    },
  },
  mounted() {
    this.onResize();
    this.$refs.gridContainer.addEventListener("resize", this.onResize);
    window.addEventListener("resize", this.onResize);
  },

  beforeDestroy() {
    this.$refs.gridContainer.removeEventListener("resize", this.onResize);
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      let { width, height } = this.$refs.gridContainer.getBoundingClientRect();
      console.log({ grid: { width, height } });
      this.resize({
        width,
        height,
        aspectRatio: this.aspectRatio ?? 3 / 4,
        margin: this.margin ?? 0,
        count: this.children.length,
      });
    },
    resize({ width, height, aspectRatio, margin, count }) {
      let gridWidth = width - margin * 2;
      let gridHeight = height - margin * 2;

      let max = 0;
      let i = 1;
      while (i < 2000) {
        let area = this.area({
          increment: i,
          count,
          ratio: aspectRatio,
          width: gridWidth,
          height: gridHeight,
          margin,
        });
        if (area === false) {
          max = i - 1;
          break;
        }
        i++;
      }

      // remove margins
      max = max - margin * 2;
      this.itemWidth = max;
      this.itemHeight = this.itemWidth * aspectRatio;

      console.log({ width: this.itemWidth, height: this.itemHeight });
    },

    area({ increment, count, ratio, margin, width, height }) {
      let i = 0;
      let w = 0;
      let h = increment * ratio + margin * 2;
      while (i < count) {
        if (w + increment > width) {
          w = 0;
          h = h + increment * ratio + margin * 2;
        }
        w = w + increment + margin * 2;
        i++;
      }
      if (h > height || increment > width) return false;
      else return increment;
    },
  },
};
</script>

<style></style>
